import { Button, useOverlayState } from "@heroui/react";
import { Plus } from "lucide-react";

import { SupplierSheet } from "@/components/supplier/form";
import { SuppliersTable } from "@/components/supplier/table";
import { useGetAllSuppliers } from "@/hooks/api/supplier";
import { useOpenOnAddParam } from "@/hooks/useOpenOnAddParam";
import { AppPage } from "@/layouts/page";

export function SuppliersPage() {
  const { data: suppliers, isLoading: isSuppliersLoading } =
    useGetAllSuppliers();
  const { isOpen, open, close } = useOverlayState();

  useOpenOnAddParam(open);

  const count = suppliers?.length ?? 0;

  return (
    <AppPage
      action={
        <Button onPress={open}>
          <Plus className="size-4" />
          Add supplier
        </Button>
      }
      subtitle={
        suppliers ? (
          <>
            <span className="tabular-nums">{count}</span>{" "}
            {count === 1 ? "supplier" : "suppliers"}
          </>
        ) : (
          "Manage product suppliers and vendors"
        )
      }
      title="Suppliers"
    >
      <SuppliersTable
        isLoading={isSuppliersLoading}
        suppliers={suppliers ?? []}
      />
      <SupplierSheet isOpen={isOpen} supplier={null} onClose={close} />
    </AppPage>
  );
}
